import { Controller } from "@hotwired/stimulus";

// turbo-refresh-scroll is "preserve" app-wide, so a panel at the top goes unseen.
export default class extends Controller {
  connect() {
    this.element.scrollIntoView({ behavior: "smooth", block: "center" });
  }
}
